import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { BaseInputComponent } from 'app/components/ui-kit/inputs/base-input/base-input.component';
import { AlertMessageComponent } from 'app/components/ui-kit/alerts/alert-message/alert-message.component';
import { SpinnerComponent } from 'app/components/ui-kit/loaders/spinner/spinner.component';
import { SplitPageWrapperComponent } from 'app/components/ui-kit/page-components/split-page-wrapper/split-page-wrapper.component';
import { AuthService } from 'app/services/auth.service';
import { ThemeService } from 'app/services/theme.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-forgot',
  standalone: true,
  imports: [CommonModule, FormsModule, SvgLoaderComponent, SplitPageWrapperComponent,
    BaseInputComponent, PrimaryBtnComponent, AlertMessageComponent, SpinnerComponent,
  RouterModule],
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.scss'
})
export class ForgotComponent {
  email = '';
  errorMessage = '';
  successMessage = '';
  currentTheme: string = '';
  ctaText: string = 'Your AI Assistant for Efficient Private Travel';
  isSending: boolean = false;

  constructor(private authService: AuthService, private themeService: ThemeService) {
    this.currentTheme = this.themeService.getCurrentTheme();
  }

  async sendResetEmail() {
    this.isSending = true;
    this.errorMessage = '';
    this.successMessage = '';
    try {
      await this.authService.forgotPassword(this.email);
      this.successMessage = 'If an account exists for the email you provided, you can use the email link to reset your password';
    } catch (error) {
      this.errorMessage = 'Failed to send reset email.';
    }
    this.isSending = false;
  }

}
